module.exports = __webpack_public_path__ + "img/IMG-20200316-WA0037.891605e2.jpg";